import { Button, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the magic button
 * 
 * @param {Object} props The props of the component
 * @returns The magic button
 */
const MagicButton = ({ icon, isSelected, title, ...props }) => (
  <Button fontSize={"xs"} variant={"magic"} {...props}>
    <VStack whiteSpace={"normal"}>
      {icon && <Icon as={icon} boxSize={"40px"} />}
      {title && (
        <Text color={"white"} fontWeight={400} fontSize={"12px"} wordBreak={"keep-all"}>
          {title}
        </Text>
      )}
    </VStack>
  </Button>
);

export default React.memo(MagicButton);
